export default {
  title: 'Creditcard toevoegen',
  buttons: {
    save: 'Opslaan',
  },
  feedback: {
    success: 'Kaart succesvol toegevoegd',
  },
};
